import { render, staticRenderFns } from "./integralCenter.vue?vue&type=template&id=10992e65&scoped=true&"
import script from "./integralCenter.vue?vue&type=script&lang=js&"
export * from "./integralCenter.vue?vue&type=script&lang=js&"
import style0 from "./integralCenter.vue?vue&type=style&index=0&id=10992e65&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10992e65",
  null
  
)

export default component.exports